import React, { type ReactElement } from 'react';

import Image from 'next/image';

import { type CollectionItemByID } from '@/common/types/collection.type';

import Text from '@/common/components/text/text.component';

interface Props {
  collection: CollectionItemByID;
}

export default function Header({ collection }: Props): ReactElement {
  return (
    <div className="relative z-0 mb-0 mt-[-100px] w-full overflow-hidden lg:hidden">
      <div className="relative h-[230px] w-full lg:hidden ">
        <Image
          width={345}
          height={230}
          src={collection?.collectionImage || ''}
          alt={collection.title}
          className="h-full w-full"
        />
        <div className="absolute inset-0 bg-collection-card-gradient"></div>

        <div className="absolute bottom-4 right-0 flex w-full flex-col items-start justify-start gap-y-1 px-3">
          <Text className="text-[16px] font-semibold text-white">
            {collection?.title}
          </Text>

          <Text className="text-xs font-medium text-white">
            {collection?.description}
          </Text>
        </div>
      </div>
    </div>
  );
}
